
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Dashboard from '../pages/dashboard/page';
import ProjectsOverview from '../pages/projects/overview/page';
import ProjectDetails from '../pages/projects/details/page';
import Calendar from '../pages/calendar/page';
import NewLeads from '../pages/leads/page';
import FollowUps from '../pages/followups/page';
import Misc from '../pages/misc/page';
import Activity from '../pages/activity/page';
import NotFound from '../pages/NotFound';
import Profile from '../pages/profile/page';
import Settings from '../pages/settings/page';
import Admin from '../pages/admin/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/projects',
    element: <ProjectsOverview />,
  },
  {
    path: '/projects/:category',
    element: <ProjectDetails />,
  },
  {
    path: '/calendar',
    element: <Calendar />,
  },
  {
    path: '/leads',
    element: <NewLeads />,
  },
  {
    path: '/followups',
    element: <FollowUps />,
  },
  {
    path: '/activity',
    element: <Activity />,
  },
  {
    path: '/misc',
    element: <Misc />,
  },
  {
    path: '/profile',
    element: <Profile />
  },
  {
    path: '/settings',
    element: <Settings />
  },
  {
    path: '/admin',
    element: <Admin />
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
